import { find } from 'lodash';
import { Order } from '../../brands/models/Order';
export const getIdsBySearchServiceModel = async ({ bffUri, searchServiceModel, page = 1, order = Order.Recency, pageSize, endpoint, }) => {
    // FIXME: body json.stringify issues with coma serialization (see search with UseFor param -> 500)
    // -> root cause comes from the serialization done when changing the querystring (after a new search)
    const response = await fetch([bffUri, endpoint].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            criteria: searchServiceModel,
            paging: {
                page,
                size: pageSize,
                order,
            },
        }),
        signal: AbortSignal.timeout(5000),
    });
    if (response.ok) {
        const { totalCount, classifieds = [] } = (await response.json());
        return {
            totalCount,
            classifieds: classifieds.map(({ id, legacyIds }) => id || find(legacyIds, { key: 'IwtGok' })?.value || 'unknown'),
        };
    }
    return { totalCount: 0, classifieds: [] };
};
